import React, { useState} from 'react'
import { Popup } from 'antd-mobile'
import '../styles/EditRecommendationModal.css'
import { workoutTypeOptionsMap } from '../../../utils'

function WorkoutListModal({ visible, onClose, onSelect }) {

    const [selectedOption, setSelectedOption] = useState('')

    return (
        <Popup
            visible={visible}
            onMaskClick={onClose}
            onClose={onClose}
            position="bottom"
            bodyClassName="modal-popup"
        >
            <div className="popup-inner-rounded">
                <div className="modal-header">
                    <h2>Workout Name</h2>
                    <button className="modal-close-btn" onClick={onClose}>Close</button>
                </div>

                <div className="workout-list-container">
                    {Object.entries(workoutTypeOptionsMap).map(([category, options]) => (
                        <div key={category}>
                            {options.map(({ label, value }) => (
                                <div
                                    key={value}
                                    className={`option-item ${selectedOption === value ? 'selected' : ''}`}
                                    onClick={() => {
                                        setSelectedOption(value)
                                        onSelect(value, category)
                                    }}
                                >
                                    {label}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </Popup>
    )
}

export default WorkoutListModal
